import { useCallback } from "react";

import { MsinsLeadEntry } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

export const usePostMsinsLead = () => {
  const postMsinsLead = useCallback(async (source: MsinsLeadEntry) => {
    const fp = PropallyApiFactory();
    try {
      const res = await fp.v1MsinsLeadsPost(source, { withCredentials: true });
      return { success: true, message: res.data.message };
    } catch (error) {
      console.error("Failed to post msins lead:", error);
      return { success: false, error };
    }
  }, []);

  return { postMsinsLead };
};
